import { Helmet } from './components/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';

const homepageSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: '少妇护肤美容指南',
      url: 'https://meirong01.github.io/',
      description: '专为少妇群体打造的全方位护肤美容指南',
    },
    {
      '@type': 'WebSite',
      name: '少妇护肤美容指南',
      url: 'https://meirong01.github.io/',
      description: '专为少妇群体打造的全方位护肤美容指南，涵盖肌肤特点分析、抗衰保湿、身材管理、产后修复等核心内容。',
      inLanguage: 'zh-Hans',
    },
    {
      '@type': 'WebPage',
      name: '首页 - 少妇护肤美容指南',
      url: 'https://meirong01.github.io/',
      description: '专为少妇群体打造的全方位护肤美容指南',
      isPartOf: { '@id': 'https://meirong01.github.io/#website' },
      about: { '@id': 'https://meirong01.github.io/#organization' },
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '少妇肌肤和年轻女性肌肤有什么不同？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '少妇肌肤（通常指25-40岁女性）面临胶原蛋白加速流失、锁水能力下降、色素沉着增多等独特挑战。与20岁出头的年轻肌肤相比，少妇肌肤更需要注重抗衰、深层保湿和屏障修复。',
          },
        },
        {
          '@type': 'Question',
          name: '每天护肤需要多长时间？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '我们推荐"早晚各15分钟"的高效护肤方案。晨间以清洁、防护、保湿为主，晚间以深洁、修复、滋养为主。关键在于每一步都做到位，而不是步骤越多越好。',
          },
        },
        {
          '@type': 'Question',
          name: '产后多久可以开始使用功能性护肤品？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '一般建议产后3个月内以温和保湿和修复为主。3个月后可以逐步加入功能性产品，如维C精华（提亮）、胜肽精华（抗衰）。视黄醇类产品建议哺乳期结束后再使用。',
          },
        },
        {
          '@type': 'Question',
          name: '口服胶原蛋白真的有效吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '近年来的研究表明，水解胶原蛋白肽确实可以通过刺激皮肤成纤维细胞来促进自身胶原蛋白的合成。但效果因人而异，需要选择分子量合适的产品（2000-5000道尔顿），配合维生素C，并坚持至少8周以上才能看到改善。',
          },
        },
        {
          '@type': 'Question',
          name: '如何判断自己的肤质？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '最简单的方法是"裸脸观察法"：晚上洁面后不涂抹任何护肤品，第二天早上观察。全脸出油明显为油性肤质；T区出油、两颊偏干为混合性；全脸紧绷甚至起皮为干性；泛红、刺痛、发热则为敏感性。',
          },
        },
        {
          '@type': 'Question',
          name: '防晒霜需要每天使用吗？冬天和室内也需要吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '是的，防晒是护肤的基石，无论季节和天气。UVA（导致光老化的紫外线）可以穿透云层和玻璃，即使在室内靠窗的位置也需要防护。建议每天使用SPF30以上、PA+++以上的防晒产品。',
          },
        },
      ],
    },
  ],
};

export default function Home() {
  return (
    <>
      <Helmet>
        <title>少妇护肤美容指南｜专为少妇定制的肌肤管理方案</title>
        <meta name="description" content="专为少妇群体打造的全方位护肤美容指南，涵盖少妇肌肤特点分析、抗衰保湿、身材管理、产后修复等核心内容，帮助每一位少妇重拾自信光彩，科学护肤从现在开始。" />
        <meta name="keywords" content="少妇,少妇护肤,少妇美容,少妇肌肤管理,少妇抗衰老,少妇产后修复,少妇身材管理" />
        <link rel="canonical" href="https://meirong01.github.io/" />
        <meta property="og:title" content="少妇护肤美容指南｜专为少妇定制的肌肤管理方案" />
        <meta property="og:description" content="专为少妇群体打造的全方位护肤美容指南，涵盖肌肤特点分析、抗衰保湿、身材管理、产后修复等核心内容。" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://meirong01.github.io/" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="少妇护肤美容指南｜专为少妇定制的肌肤管理方案" />
        <meta name="twitter:description" content="专为少妇群体打造的全方位护肤美容指南，涵盖肌肤特点分析、抗衰保湿、身材管理、产后修复等核心内容。" />
        <script type="application/ld+json">
          {JSON.stringify(homepageSchema)}
        </script>
      </Helmet>

      <Navbar />

      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedArticles />
        <FAQSection />
        <NewsletterSection />
      </main>

      <Footer />
      <ScrollToTop />
    </>
  );
}